
/** 默认生成文案字数输入框的数字 */
export const DEFAULT_COPYWRITING_LENGTH = 800;

